import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface IGetVideoUrlApiParameter extends ApiParameter {
    id: string;
}

export interface IGetVideoUrlModel extends BaseModel {
    videoURL: string;
}

const documentsUrl = "/api/v1/documents/";

export function getVideoUrlService(parameter: IGetVideoUrlApiParameter) {
    return get<IGetVideoUrlModel>(`${documentsUrl}/${parameter.id}`);
}
